const avatarNameMixin = {
    methods: {
        avatarName(string) {
            return string.split(".")[0].charAt(0).toUpperCase() + string.split(".")[1].charAt(0).toUpperCase()
        }
    }
};

export default avatarNameMixin;
